import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import { Hero } from '../components/Hero'

import { Constrain } from '../components/@primitives/constrain'
import { Button } from '../components/@primitives/button'
import { TextCard } from '../components/TextCard'

import styled, { css } from 'react-emotion'
import { colors } from '../styles/vars'
import { Image } from '../components/Image'
import { SideBySide } from '../components/SideBySide'

const Grid = styled('div')`
  box-sizing: border-box;
  display: grid;
  grid-template-columns: repeat(${props => props.columns ? props.columns : 3}, 1fr);
  grid-gap: ${props => props.gap ? props.gap : 60}px;
  z-index: 1;
  position: relative;
   
  @media (max-width: 768px) {
    grid-template-columns: repeat(${props => props.mobile ? props.mobile : 2}, 1fr);
  }
`

const arrow = css`
  position: relative;
  z-index: 1;
  background-color: #f5f5f5;
  
  img {
    width: 100%;
    z-index: 1;
  }
`

const IndexPage = ({ data: { products: { group: products}}}) => (
    <div>
      <Helmet
        title="Just In Time"
        meta={[
          {
            name: 'description',
            content: 'We serve the entire United States with same-day shipment of Digester Blow Valves, Liquor Valves, Check Valves and other Digester Valves!"',
          },
        ]}
      />
      <Hero
        image={"/images/homepageValve.png"}
        heading={"Just In Time."}
        content={"We serve the entire United States with same-day shipment of Digester Blow Valves, Liquor Valves, Check Valves and other Digester Valves!"}
        to={"/contact"}
        text={"Request A Quote"}
        imageUrl={"/liquor-valves"}
      />
      <section className={css`background-color: #f5f5f5; padding-bottom: 40px;`}>
        <div className={arrow}>
          <img src="/images/heroArrow.svg" alt=""/>
        </div>
        <Constrain>
          <div className={css`max-width: 70%; margin: 0 auto 60px; text-align: center; @media (max-width: 768px) { max-width: 100%; }`}>
            <h2>We're Ready When You Are</h2>
            <p>We know valve failures rarely happen at convinient times, which is why we pride ourselves on having the best customer service whether it’s 2pm or 2am. </p>
          </div>
          <Grid columns={3} mobile={1}>
            <TextCard
              heading="Same Day Shipping"
              copy="We offer same day shipping to the entire United States. Call us today to see how quickly we can get you what you need!"
            />
            <TextCard
              heading="24 Hr Response"
              copy="Whether it’s 2pm or 2am, AVI specializes in getting you the right valve at the right time. Call us today to see how quickly we can get you what you need!"
            />
            <TextCard
              heading="Valves In-Stock"
              copy="We know valve failures rarely happen at convenient times, which is why we stock many of the valves you need in our warehouse to better serve you!"
            />
          </Grid>
          <div className={css`max-width: 70%; margin: 40px auto 60px; text-align: center; @media (max-width: 768px) { max-width: 100%; }`}>
            <h2>Digester Valves</h2>
            <p>We are NAF’s Exclusive Master Distributor for the entire United States. Give us a call to see how we can help meet your needs!</p>
          </div>
          <Grid columns={4} mobile={1} gap={10}>
            {products.map((product, i) => {
              if (product.edges[0].node.frontmatter.category === 'Control Valves') {
                return (
                  <Image
                    key={i}
                    to={product.edges[0].node.frontmatter.path}
                    image={product.edges[0].node.frontmatter.image}
                  >
                    {product.edges[0].node.frontmatter.category}
                  </Image>
                )
              }
            })}
            {products.map((product, i) => {
              if (product.edges[0].node.frontmatter.category !== 'Control Valves') {
                return (
                  <Image
                    key={i}
                    to={product.edges[0].node.frontmatter.path}
                    image={product.edges[0].node.frontmatter.image}
                  >
                    {product.edges[0].node.frontmatter.category}
                  </Image>
                )
              }
            })}
          </Grid>

        <hr className={css`max-width: 25vw; margin: 80px auto;`}/>

          <SideBySide
            image={"/images/avi_team.jpg"}
            align={"left"}
            heading={"About AVI"}
            copy={"Advanced Valve and Instrument, Inc. began operations in mid-1994 with a focus on being a short turnaround supplier of automated quarter turn valves. Since our beginning, that vision has expanded to include instrumentation and valve application seminars, classes, and valve application consulting."}
            to={"/about"}
            text={""}
            narrow
          />
        </Constrain>
      </section>
    </div>
)

export default IndexPage

export const query = graphql`
    query PageQuery {
        products: allMarkdownRemark(sort: {fields: [frontmatter___category]}) {
            group (field: frontmatter___path) {
                edges {
                    node {
                        frontmatter {
                            path
                            category
                            image
                        }
                    }
                }
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/pages/index.js